import axios from '@/libs/axios';
import { debounce } from 'lodash';
import { computed,ref,watch } from '@vue/composition-api';

export default function useList() {
  //DATA
    const currentPage = ref(1);

    const isSortDirDesc = ref(true);

    const perPage = ref(10);

    const perPageOptions = [10, 25, 50, 100]

    const refListTable = ref(null);

    const searchQuery  = ref("");

    const sortBy = ref('start');

    const tableColumns  = [
      { key: 'user.user', label: 'Usuario'},
      { key: 'workstation', label: 'Workstation' },
      { key: 'telephone_lines', label: 'Líneas telefónicas' },
      { key: 'start', label: 'Inicio' },
      { key: 'end', label: 'Fin' },
      { key: 'active', label: 'Activo' },
    ];

    const totalList = ref(0);

    //COMPUTED
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalList.value,
      };
    });


    //METHODS
    const fetchList = (ctx, callback) => {
      const params = {
        q: searchQuery.value,
        max: perPage.value,
        'page[n]': currentPage.value
      }

      axios.get('v1/user-shifts', { params } )
        .then(response => {
          console.log('object');
          callback(response.data.data)
          totalList.value = response.data.meta.total
        })
        .catch((error) => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error obteniendo la información',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        });
    }

    const refetchData = () => { refListTable.value.refresh(); };

    //WATCHERS
    watch([currentPage, perPage, sortBy, isSortDirDesc], () => {
      refetchData();
    });

    watch([searchQuery ], debounce(() => {
      refetchData();
    }, 500));

    return {
      fetchList,
      tableColumns,
      perPage,
      perPageOptions,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
    }
}
